import { ActionReducerMap } from "@ngrx/store";
import { LayoutState, layoutReducer } from "./layouts/layout-reducers";
import { authenticationReducer, AuthenticationState } from "./Authentication/authentication.reducer";
import { ClientState, clientReducer } from "./Client/client.reducer";
import { TeamMemberState, teammemberReducer } from "./TeamMember/teammember.reducer";
import { PlansetReducer, PlansetState } from "./Planset/planset.reducer";
import { ServiceChargesReducer, ServiceChargesState } from "./ServiceCharges/servicecharges.reducer";
import { DataentryReducer, DataentryState } from "./Dataentry/dataentry.reducer";
import { CommonState, commonReducer } from "./common/common.reducer";
import { SalesproposalReducer, SalesproposalState } from "./Salesproposal/salesproposal.reducer";
import { SubscriptionState, subscriptionReducer } from "./subscription/subscription.reducer";
import { PestampReducer, PestampState } from "./Pestamp/pestamp.reducer";
import { dashboardReducer, DashboardState } from "./Dashboard/dashboard.reducer";

import { TicketReducer, TicketState } from "./Ticket/ticket_reducer";
import { StampingpartnerReducer, StampingpartnerState } from "./StampingPartner/stampingpartner.reducer";

export interface RootReducerState {
    layout: LayoutState;
    authentication: AuthenticationState;
    clients: ClientState;
    teams: TeamMemberState;
    plansets: PlansetState;
    salesproposals: SalesproposalState;
    pestamps: PestampState;
    servicecharges: ServiceChargesState
    dataentry: DataentryState,
    common: CommonState,
    subscription: SubscriptionState,
    dashboard:DashboardState
    ticket: TicketState,
    stampingpartners: StampingpartnerState
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
    layout: layoutReducer,
    authentication: authenticationReducer,
    clients: clientReducer,
    teams: teammemberReducer,
    plansets: PlansetReducer,
    salesproposals: SalesproposalReducer,
    pestamps: PestampReducer,
    servicecharges: ServiceChargesReducer,
    dataentry: DataentryReducer,
    common: commonReducer,
    subscription: subscriptionReducer,
    dashboard:dashboardReducer,
    ticket: TicketReducer,
    stampingpartners: StampingpartnerReducer
}